import Service from "../Service"

const industry = {
  getIndustries() {
    return Service.get(`/api/frontend/industry/all`)
  },
}

export default industry
